module.exports = __webpack_public_path__ + "img/tooltip_dark.8f1a5858.svg";